import React from 'react';

import {Badge, Icon} from '@albert-io/atomic';
import type {ClassroomV1} from '@albert-io/models';
import {getClassroomDomainBackgroundClass} from 'client/Classrooms/classroomDomainColor';

interface ClassroomFlairProps {
  isForAll: boolean;
  classroom?: ClassroomV1;
}

export default function ClassroomFlair({isForAll, classroom}: ClassroomFlairProps) {
  'use memo';

  if (isForAll) {
    return (
      <Badge
        className='mr-x1 p-x0-quarter'
        status='info'
        size='small'
        roundness='square'
        aria-hidden='true'
      >
        <Icon icon='home' iconStyle='regular' fixedWidth />
      </Badge>
    );
  }

  const initial = classroom?.getName?.()?.charAt(0).toUpperCase() ?? '';
  const domainClass = getClassroomDomainBackgroundClass(classroom);

  return (
    <Badge
      className={`mr-x1 ${domainClass} content-primary-inverse-static border-none font-bold! [&>.a-text]:leading-none`}
      size='small'
      roundness='circle'
      aria-hidden='true'
    >
      {initial}
    </Badge>
  );
}
